<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">

                <div id="search-box-index">
                    <div class="ebc-tabs no-scrollbar">
                        <a href="/jinrong/mt4/" class="ebc-tab-line-item"> MT4 </a>
                        <a href="/jinrong/mt5/" class="ebc-tab-line-item"> MT5 </a>
                        <a href="javascript:;" class="ebc-tab-line-item ebc-tab-line-item-selected">
                            Trading Central
                        </a>
                        <a href="/jinrong/trading-view/" class="ebc-tab-line-item">
                            Trading View
                        </a>
                    </div>
                </div>
                <h1 class="">Trading Central</h1>
                <div class="forex-title-intro">
                    Trading
                    Central是一套由专业分析师支持的金融研究工具，集成于多家交易平台中。<br />
                    它提供技术分析信号、趋势判断、策略建议、关键位识别等内容，涵盖外汇、指数、商品、美股等资产类别。<br />
                    通过图表叠加、情绪分析、AI智能洞察，Trading Central
                    帮助交易者在复杂市场中获取更清晰的交易判断。适用于新手与资深投资者。
                </div>
                <div class="forex-btn-group">
                    <ebc-btn class="ebc-btn">立即获取</ebc-btn>
                </div>
                <section class="section1 mt-50">
                    <h2 class="">Trading Central基础教程</h2>
                    <div class="swiper document-list-wrapper1">
                        <swiper ref="swiperBasic" :options="swiperBasicOptions" class="document-list">
                            <swiper-slide v-for="vo in basicList" :id="vo.id">
                                <div class="document-item">
                                    <a :href="vo.url.replace('/zh-cn', '')" class="document-item-img-box">
                                        <img class="document-item-img" :src="vo.thumbnail" :alt="vo.post_title" />
                                    </a>
                                    <div>
                                        <a :href="vo.url.replace('/zh-cn', '')" class="document-item-title">{{
                                            vo.post_title }}</a>
                                        <div class="document-btn-text">
                                            {{ formateTime(vo.published_time) }}
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </section>
                <section class="section2">
                    <h2 class="">Trading Central相关问题</h2>
                    <div class="QA-list">
                        <div class="QA-item">
                            <div class="QA-title">
                                1. Trading Central 是什么？对交易者有哪些帮助？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    Trading Central
                                    是一家提供量化研究与市场分析服务的公司，为交易者提供技术面、基本面和情绪面的多维信号，帮助做出更明智决策。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                2. 如何使用 Trading Central 的信号和分析报告？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    EBC提供多种Trading
                                    Central的插件和分析栏目交易信号等内容。可直接通过官网领取或者下载MT4、MT5进行使用。
                                </p>
                            </div>
                        </div>

                        <div class="QA-item">
                            <div class="QA-title">
                                3. Trading Central 支持哪些交易产品分析？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    涵盖外汇、股指、黄金、原油、美股、欧股等主要金融市场。内容包括关键支撑阻力位、图形形态、日内策略建议等。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                4. Trading Central 的信号准吗？是否值得参考？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    Trading Central
                                    提供的是专业分析建议而非交易指令，建议结合个人策略、风险承受能力与其他工具辅助判断使用。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                5. Trading Central 插件如何安装到 MT4 / MT5？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    EBC的交易平台提供一键接入功能，解锁完成版后交易软件会在图表工具栏或独立窗口中显示
                                    Trading Central 分析插件。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                6. Trading Central 是否收费？普通投资者可以使用吗？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    通常由经纪商付费集成，用户可免费使用。具体以您开户的平台权限为准。
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import moment from 'moment';
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getTradingCentralTutorial } from '../../serve/forex.js';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'


export default {
    components: {
        forexMenu,
         Swiper, SwiperSlide
    },
    data() {
        return {
            basicList: [],
            advancedList: [],
            swiperBasicOptions: {
                slidesPerView: 1.1,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
            swiperAdvancedOptions: {
                slidesPerView: 3,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
        }
    },
    created() {
        getTradingCentralTutorial().then(response => {
            console.log("getMT5Tutorial", response)
            if (response.status && response.status == '200') {
                this.basicList = response.data.data.basic
                this.advancedList = response.data.data.advanced
            }

        }).catch(err => {
            this.basicList = []
            this.advancedList = []
        })
    },
    methods: {
        formateTime(time) {
            return moment.unix(new Date(time)).format("YYYY-MM-DD")
        },
    },
    mounted() {
       // 获取所有的QA-item元素
            var qaItems = document.querySelectorAll(".QA-item");

            // 遍历每个QA-item，为其添加点击事件监听器
            qaItems.forEach(function (item) {
                item.addEventListener("click", function () {
                    // 获取当前点击的QA-content元素
                    var content = this.querySelector(".QA-content");

                    // 如果点击的QA-content是隐藏的，则展示它；反之则隐藏
                    if (content.style.display === "none" || content.style.display === "") {
                        // 移除所有其他QA-item上的.QA-actived类，并隐藏其QA-content
                        qaItems.forEach(function (otherItem) {
                            otherItem.querySelector(".QA-content").style.display = "none";
                            otherItem.classList.remove("QA-actived");
                        });

                        // 展示当前点击的QA-content，并为当前QA-item添加.QA-actived类
                        content.style.display = "block";
                        this.classList.add("QA-actived");
                    } else {
                        // 如果已经是显示状态，则隐藏并移除.QA-actived类
                        content.style.display = "none";
                        this.classList.remove("QA-actived");
                    }
                });
            });
        

    }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}
</style>